import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { allService } from '../services';

export default function ConnectionGuard2({ component: C, appProps, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!appProps.isAuthenticated || allService.empty(appProps.userRole)) {
          //logged in so redirect to transac page with the return url
          return <Redirect to={{ pathname: '/login' }} />;
        } else if (
          appProps.isAuthenticated &&
          !(appProps.userRole === appProps.defineRole)
        ) {
          return (
            <Redirect
              to={`/login?redirect=${props.location.pathname}${props.location.search}`}
            />
          );
        }
        // authorised so return component
        return <C {...props} />;
      }}
    />
  );
}
